import React, { useEffect, useState } from "react";
import UserTable, { usePaginatedUsers } from "./UserTable";
import { AddUserForm } from "./AddUserForm";
import { EditUserForm } from "./EditUserForm";
import { UserInfoModal } from "./UserInfoModal";
import { ConfirmModal } from "./ConfirmModal";
import { getUtilComUtc, createUser, updateUser, deleteUser } from "../../api/users";
import { getCommunications } from "../../api/communications";

export default function DispositifUsersList() {
  const state = usePaginatedUsers(getUtilComUtc);
  const [colleges, setColleges] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const [infoItem, setInfoItem] = useState(null);
  const [confirmItem, setConfirmItem] = useState(null);

  useEffect(() => {
    getCommunications()
      .then((data) => setColleges(data.items || []))
      .catch((e) => console.error("Erreur chargement collèges", e));
  }, []);

  const handleCreate = async (payload) => {
    const created = await createUser(payload);
    state.setItems((prev) => [created, ...prev]);
    setShowAddForm(false);
  };

  const handleSave = async (utcId, patch) => {
    const updated = await updateUser(utcId, patch);
    state.setItems((prev) =>
      prev.map((it) => (it.utcId === utcId ? { ...it, ...updated } : it))
    );
    setEditingId(null);
  };

  const confirmDelete = async () => {
    const item = confirmItem;
    if (item.utcActif) return;
    setDeletingId(item.utcId);
    try {
      await deleteUser(item.utcId);
      state.setItems((prev) => prev.filter((it) => it.utcId !== item.utcId));
      if (editingId === item.utcId) setEditingId(null);
      setConfirmItem(null);
    } catch (e) {
      alert(e.message);
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <>
    <UserTable
      title='Utilisateurs "Dispositif"'
      state={state}
      rowKey={(item) => item.utcId}
      headerActions={
        <button
          type="button"
          className="btn fr-btn"
          onClick={() => setShowAddForm((v) => !v)}
        >
          + Ajouter
        </button>
      }
      searchFields={[
        { key: "utcNom", placeholder: "Rechercher par nom..." },
        { key: "utcMail", placeholder: "Rechercher par email..." },
      ]}
      expandedRowKey={editingId}
      renderExpandedRow={(item) => (
        <EditUserForm
          user={item}
          colleges={colleges}
          onCancel={() => setEditingId(null)}
          onSave={handleSave}
        />
      )}
      columns={[
        { key: "utcNom", label: "Nom", sortKey: "utcNom" },
        { key: "utcMail", label: "Email", sortKey: "utcMail" },
        {
          key: "comId",
          label: "COM_ID",
          sortKey: "com.comCode",
          render: (item) => item.comCode  ?? "—",
        },
        { key: "utcRole", label: "Rôle", sortKey: "utcRole" },
        {
          key: "utcActif",
          label: "État",
          sortKey: "utcActif",
          render: (item) => (
            <span style={{ color: item.utcActif ? "#2fb344" : "#d63939", fontWeight: 600 }}>
              {item.utcActif ? "Actif" : "Inactif"}
            </span>
          ),
        },
        {
          key: "actions",
          label: "Action(s)",
          render: (item) => (
            <div style={{ display: "flex", gap: 8 }}>
              <button
                type="button"
                className="btn fr-btn"
                onClick={() => setEditingId(editingId === item.utcId ? null : item.utcId)}
              >
                Modifier
              </button>
              {!item.utcActif && (
                <button
                  type="button"
                  className="fr-btn--danger"
                  disabled={deletingId === item.utcId}
                  onClick={() => setConfirmItem(item)}
                >
                  {deletingId === item.utcId ? "Suppression…" : "Supprimer"}
                </button>
              )}
            <button
                type="button"
                className="btn fr-btn--secondary"
                title="Dates de création/modification, connexions"
                onClick={() => setInfoItem(item)}
            >
              …
            </button>
            </div>
          ),
        },
      ]}
    />
    {showAddForm && (
      <AddUserForm
        colleges={colleges}
        onCancel={() => setShowAddForm(false)}
        onCreate={handleCreate}
      />
    )}
    <UserInfoModal user={infoItem} onClose={() => setInfoItem(null)} />
    <ConfirmModal
      open={!!confirmItem}
      title="Supprimer l'utilisateur"
      message={`Supprimer l'utilisateur "${confirmItem?.utcNom}" ? Cette action est irréversible.`}
      confirming={deletingId === confirmItem?.utcId}
      onConfirm={confirmDelete}
      onCancel={() => setConfirmItem(null)}
    />
    </>
  );
}
